import styled, { keyframes } from 'styled-components';

const floatUp = keyframes`
	0%   { transform: translateY( 28px ); opacity: 0; }
	60%  { transform: translateY( -5px ); opacity: 1; }
	80%  { transform: translateY(  3px ); opacity: 1; }
	100% { transform: translateY(  0px ); opacity: 1; }
`;

export const SparksBadgeWrapper = styled.div`
	display: flex;
	align-items: center;
	cursor: pointer;
	background: rgba(255, 255, 255, 0.12);
	border-radius: 40px;
	padding: 4px 14px 4px 6px;
	gap: 8px;
	transition: background 0.2s ease;
	user-select: none;

	&:hover {
		background: rgba(255, 255, 255, 0.22);
	}

	.spark-coin-img {
		width: 32px;
		height: 32px;
		object-fit: contain;
		animation: ${floatUp} 1.4s ease-in-out 3s 1 both;
	}

	.spark-info {
		display: flex;
		flex-direction: column;
		line-height: 1.15;

		.spark-count {
			font-size: 14px;
			font-weight: 700;
			color: #fff;
		}

		.spark-label {
			font-size: 10px;
			color: rgba(255, 255, 255, 0.7);
			font-weight: 500;
		}
	}

	.spark-loading {
		width: 16px;
		height: 16px;
	}
`;
